import React, { useState, useEffect } from "react";
import banner from "../../../assets/sectbanner.webp";
import Header from "../Header";
import Footer from "../Footer/Footer";
import "./AllPrograms.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import gateway from "../../../assets/experiance/gateway.webp";
import wellness from "../../../assets/experiance/wellness.webp";
import yoga from "../../../assets/experiance/yoga.webp";
import corporate from "../../../assets/experiance/corporate.webp";
import friends from "../../../assets/experiance/friends.webp";
import school from "../../../assets/experiance/school.webp";
import sportretreate from "../../../assets/experiance/sportretreate.webp";
// import { getTable } from "../../../config/seatable";

import api from "../../../config/axiosConfig";

function ExperiencePage() {
  const [programs, setPrograms] = useState([]);
  const fixURL = (url) =>{
    if(!url) return "";
    return url.replace( "https://cloud.seatable.io/workspace",
    "https://cloud.seatable.io/dtable-server/media/workspace");
  };

  const programsImages = [
    { id: 1, name: "Getaway", programId: 1, image: gateway },
    { id: 2, name: "Wellness", programId: 2, image: wellness },
    { id: 3, name: "Yoga, Fitness, Meditation", programId: 3, image: yoga },
    { id: 4, name: "Corporate Offsite", programId: 4, image: corporate },
    { id: 6, name: "Friends & Family Retreat", programId: 6, image: friends },
    { id: 7, name: "School Camp", programId: 7, image: school },
    { id: 8, name: "Sports Retreat", programId: 14, image: sportretreate },
  ];

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const response = await api.get("database")
        console.log("all programs:", response.data.programs || []);
        
        setPrograms(response.data.programs || []); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchProgram();
  }, []);

  return (
    <>
      <Header />
      <section className="ExperiencePage">
        {/* Banner Section */}
        {/* <div className="inner-banner pb-5" id="hero">
          <div className="bannar">
            <img src={banner} alt="banner" loading="lazy" />
          </div>
          <div className="bannar-text-div">
           
            <h2 className="bannar-text">Programs</h2>
          </div>
        </div> */}

        {/* Getaways Section */}
        <section className="getaways px-md-5 px-3 pb-5">
          <div className="p-md-5 p-0">
         <div className="text-center"><h2 className="bannar-text pb-5">Programs</h2></div>
            {programs.map((program, index) => {
              const matchedImage = programsImages.find(
                (img) => img.name === program["bTjl"]
              );

              return (
                <Row
                    key={program.id}
                    className={`g-0 ${index % 2 === 0 ? "flex-row-reverse" : ""} mb-5 m-sm-0 program-row`}
                  >
                    <Col
                      sm={6}
                      xs={{ order: 1 }} // Image always comes first on small screens
                      className="gateway-image d-flex align-items-stretch"
                    >
                      <img
                        src={matchedImage ? matchedImage.image : gateway}
                        alt={program.name}
                        className="experience-img img-fluid w-100"
                        loading="lazy"
                      />
                    </Col>
                    <Col
                      sm={6}
                      xs={{ order: 2 }} // Text always comes second on small screens
                      className="d-flex align-items-stretch program-box"
                    >
                      <div className="program-div">
                        <h3>{program["bTjl"]}</h3>
                        <p>{program["08nm"] || "No description available."}</p>
                      </div>
                    </Col>
                  </Row>
              );
            })}
          </div>
        </section>
      </section>
      <Footer />
    </>
  );
}

export default ExperiencePage;
